import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { runVersionEnforcer, registerServiceWorker } from './bootstrap/versionEnforcer';
import { initPwaInstallCapture } from './pwa/pwaInstallStore';

initPwaInstallCapture();

function mountApp() {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}

if (runVersionEnforcer()) {
  registerServiceWorker().finally(mountApp);
}
